import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiListItemAvatar = {
  styleOverrides: {
    root: ({ theme }) => ({
      minWidth: theme.spacing(5),
      "& .MuiAvatar-root": {
        width: theme.spacing(3),
        height: theme.spacing(3),
        fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyXSmall,
        fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
      }
    }),
    alignItemsFlexStart: ({ theme }) => ({
      marginTop: theme.spacing(0.5)
    })
  }
};
export {
  MuiListItemAvatar
};
//# sourceMappingURL=MuiListItemAvatar.js.map
